import { Box, IconButton, Paper, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Team } from '@tassomutuo-backoffice/types';
import Tooltip from '@mui/material/Tooltip';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import React from 'react';
import { Link } from 'react-router-dom';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { CtaButton } from '@tassomutuo-backoffice/ui';

interface IProps {
  canSendEmailNotification: boolean;
  teams: Team[];
  onNotifyTeamClick: (team: Team) => void;
}

const TeamManagersTable = ({
  teams,
  onNotifyTeamClick,
  canSendEmailNotification,
}: IProps) => {
  const tableColumns: GridColDef<Team>[] = [
    {
      field: 'teamManager.email',
      headerName: 'Email',
      flex: 1,
      valueGetter: ({ row }) => row.teamManager.email,
    },
    {
      field: 'teamManager.name',
      headerName: 'Nome',
      flex: 1,
      valueGetter: ({ row }) => row.teamManager.name,
    },
    {
      field: 'membersNumber',
      headerName: 'Membri del team',
      flex: 1,
      valueGetter: ({ row }) => row.members.length,
    },
    {
      field: 'teamGroups',
      headerName: 'Gruppi',
      flex: 1,
      valueGetter: ({ row }) => row.groups.length,
    },
    {
      field: 'teamsOldestLeads',
      headerName: 'Lead non aggiornate',
      flex: 1,
      valueGetter: ({ row }) => row.statistics.oldestLead,
    },
    {
      headerName: ' ',
      field: 'send-email-alert',
      flex: 0.5,
      sortable: false,
      renderCell: ({ row }) => {
        if (!canSendEmailNotification || row.statistics.oldestLead <= 0)
          return null;
        return (
          <CtaButton variant="contained" onClick={() => onNotifyTeamClick(row)}>
            <MailOutlineIcon />
            <Typography pl={1}>Notifica</Typography>
          </CtaButton>
        );
      },
      minWidth: 130,
    },
    {
      headerName: ' ',
      field: ' ',
      flex: 0.5,
      sortable: false,
      renderCell: ({ row }) => (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Tooltip title="Apri dettaglio Team">
            <IconButton>
              <Link to={`/admin/teams/${row.id}`}>
                <OpenInNewIcon color="primary" />
              </Link>
            </IconButton>
          </Tooltip>
        </Box>
      ),
      minWidth: 80,
    },
  ];

  return (
    <div>
      <Paper sx={{ mt: 4 }}>
        <DataGrid
          columns={tableColumns}
          rows={teams || []}
          disableRowSelectionOnClick
          autoHeight
          pagination
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10, page: 0 },
            },
          }}
          pageSizeOptions={[10]}
        />
      </Paper>
    </div>
  );
};

export default TeamManagersTable;
